<template>
  <div>
    <nav class="hidden md:block secondary-nav">
      <ul>
        <li>
          <a
            :href="$urlGenerator.active('resources')"
            v-text="'All Resources'"
          />
        </li>
        <li class="ml-auto" v-can="'edit-resources'">
          <a
            :class="disabled ? 'active' : ''"
            :href="$urlGenerator.active('resources/disabled')"
            v-text="'Disabled'"
          />
        </li>
      </ul>
    </nav>
  </div>
</template>

<script type="text/babel">
export default {
  name: 'ResourceNavigation',
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
}
</script>
